import { Injectable } from '@angular/core'
import { addDoc, collection, doc, Firestore, serverTimestamp } from '@angular/fire/firestore'
import { Auth } from '@angular/fire/auth'

import { FreshTask } from '@innersight-os/shared/firestore-interfaces'

@Injectable({
  providedIn: 'root'
})
export class TasksService {
  constructor(
    private auth: Auth,
    private db: Firestore,
  ) {}

  async add(operationId: string, uploadId: string, volumeId: string, segmentationId: string, timeSpent: number) {

    const segmentationDocRef = doc(this.db, `operations/${operationId}/uploads/${uploadId}/volumes/${volumeId}/segmentations/${segmentationId}`)

    const task: FreshTask = {
      operationId,
      uploadId,
      volumeId,
      segmentationId,
      ...this.createdFields(),
      taskType: 'review',
      timeSpent,
    }

    addDoc(collection(segmentationDocRef, 'tasks'), task)
  }

  private createdFields = () => ({
    createdAt: serverTimestamp(),
    createdBy: this.auth.currentUser.uid,
  })
}
